// Mock data for HITMAX (Visifoot-style, frontend-only)

export const heroStat = { accuracy: '92,2%', matches: 879 };

export const leagues = [
  'Ligue 1', 'Premier League', 'LaLiga', 'Serie A', 'Bundesliga',
  'Ligue des Champions', 'Europa League', 'Eredivisie', 'Primeira Liga',
  'Championship', 'Liga MX', 'MLS', 'Süper Lig', 'Pro League',
];

export const featuredMatch = {
  competition: 'Ligue des Champions',
  stage: '1/2 finale · Aller',
  date: 'Mardi 6 mai · 21:00',
  home: { name: 'Real Madrid', short: 'RMA', colors: ['#ffffff', '#d9b23a'], text: '#0a0a0c' },
  away: { name: 'Inter Milan', short: 'INT', colors: ['#0a1a4f', '#0b0e18'], text: '#ffffff' },
  score: '2 - 1',
  probabilities: { home: 46, draw: 27, away: 27 },
  altScores: [
    { score: '2 - 1', pct: 13 },
    { score: '1 - 1', pct: 11 },
    { score: '2 - 0', pct: 10 },
    { score: '1 - 0', pct: 9 },
  ],
  scorers: [
    { name: 'K. Mbappé', team: 'RMA', pct: 38 },
    { name: 'L. Martinez', team: 'INT', pct: 29 },
    { name: 'Vinícius Jr', team: 'RMA', pct: 26 },
  ],
  insights: [
    'Le Real reste sur 9 victoires à domicile en C1.',
    'L’Inter possède la meilleure défense de la compétition (0,6 but/match).',
    'Value détectée sur le « plus de 2,5 buts » à la cote 1,95.',
  ],
  bookmakers: [
    { name: 'Winamax', odds1: 1.95, oddsN: 3.70, odds2: 4.10 },
    { name: 'Betclic', odds1: 1.92, oddsN: 3.65, odds2: 4.20 },
    { name: 'Unibet', odds1: 1.98, oddsN: 3.55, odds2: 4.05 },
    { name: 'ParionsSport', odds1: 1.90, oddsN: 3.80, odds2: 3.95 },
    { name: 'PMU', odds1: 1.94, oddsN: 3.60, odds2: 4.15 },
    { name: 'Bwin', odds1: 1.96, oddsN: 3.50, odds2: 4.30 },
    { name: 'Netbet', odds1: 1.93, oddsN: 3.75, odds2: 4.00 },
    { name: 'Vbet', odds1: 2.00, oddsN: 3.58, odds2: 3.90 },
  ],
};

export const features = [
  { title: 'Probabilités 1 / N / 2', text: 'Le calcul exact des chances de chaque issue, mis à jour en continu jusqu’au coup d’envoi.' },
  { title: 'Scénarios IA', text: 'HITMAX simule le déroulé du match : forces, faiblesses et moments clés de chaque équipe.' },
  { title: 'Comparateur de cotes', text: 'Les cotes de 23 bookmakers côte à côte, pour trouver la vraie valeur d’un seul coup d’œil.' },
  { title: 'Buteurs probables', text: 'Les joueurs les plus susceptibles de marquer, avec leur probabilité estimée.' },
];

export const testimonials = [
  { name: 'Maya Zong', role: 'Passionnée de football', text: 'Honnêtement bluffant. Les analyses sont claires et m’aident vraiment à comprendre les matchs, pas juste à regarder les scores.', c: '#e8c26a' },
  { name: 'Daniel Perez', role: 'Ingénieur logiciel', text: 'Je gagne un temps fou. Fini de chercher l’info partout — tout est déjà analysé au même endroit.', c: '#3b74ff' },
  { name: 'Andre Lewis', role: 'Étudiant', text: 'La première app qui ne me noie pas d’infos. Tout est calme, structuré et pensé.', c: '#3fb950' },
  { name: 'Ethan Miller', role: 'Analyste amateur', text: 'Les scénarios IA sont passionnants. On voit immédiatement les forces et faiblesses des équipes.', c: '#d7263d' },
  { name: 'Laura Kim', role: 'Product Designer', text: 'On a vraiment l’impression d’avoir un analyste pro dans la poche.', c: '#9b6bff' },
  { name: 'Priya Shah', role: 'Marketing', text: 'Les analyses d’avant-match sont incroyablement précises. Ça change ma façon de suivre les matchs.', c: '#2fbfae' },
];

export const faqs = [
  { q: 'HITMAX est-il gratuit ?', a: 'Oui, la création de compte est gratuite. Une fois inscrit, tu vois déjà les probabilités de chaque match et les vraies cotes du marché. Pour avoir accès à toutes les fonctionnalités, il faut s’abonner ou débloquer un match à l’unité.' },
  { q: 'Comment fonctionnent les analyses IA ?', a: 'HITMAX analyse des millions de données issues de plus de 220 sources pour estimer les probabilités de chaque issue et simuler le déroulé du match.' },
  { q: 'HITMAX permet-il de parier ?', a: 'Non. HITMAX est un outil d’analyse et de comparaison de cotes. La décision et le risque restent les vôtres. Le jeu comporte des risques.' },
  { q: 'Les données sont-elles fiables ?', a: 'Oui. Les analyses reposent sur des données réelles et continuellement mises à jour pour garantir la meilleure précision possible.' },
];

export const assets = {
  logo: '/assets/img2.jpeg',
  logoTall: '/assets/hitmax_logo.webp',
  introVideo: '/assets/intro.mp4',
  samuraiVideo: '/assets/samurai.mp4',
  bannerVideo: '/assets/banner.mp4?v=2',
  stadium: 'https://images.unsplash.com/photo-1611952053765-c677dedd78bb?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxzdGFkaXVtJTIwbGlnaHRzfGVufDB8fHxibGFja3wxNzg5MDQzNDMxfDA&ixlib=rb-4.1.0&q=85',
};
